import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArmchair: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="armchair, seat, chill"><path d="M3.75 11.75H7.75V14.3214H16.25V11.75H20.25V18.25H3.75V11.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18.25 11.25V3.75H5.75V11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.75 18.25V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18.25 18.25V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArmchair;
